module.exports = __webpack_public_path__ + "assets/red-and-blue-pc-ru.c1cdbfd3.svg";